import React, { useEffect, useState, useCallback } from 'react';
import { useT } from '../../context/TenantContext';
import BackDeskLayout from '../../components/layout/BackDeskLayout';
import { api } from '../../services/api';
import MIcon from '../../components/common/MIcon';
import { Button } from '../../components/ui';

export default function Departments() {
  const { t } = useT();
  const [depts,   setDepts]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing,  setEditing]  = useState(null); // dept object o null
  const [form,     setForm]     = useState({ name:'', email:'', description:'' });
  const [saving,   setSaving]   = useState(false);
  const [error,    setError]    = useState('');
  const [search,   setSearch]   = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try { setDepts(await api.getDepartments()); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const openNew = () => {
    setEditing(null);
    setForm({ name:'', email:'', description:'' });
    setError('');
    setShowForm(true);
  };

  const openEdit = (d) => {
    setEditing(d);
    setForm({ name: d.name, email: d.email, description: d.description || '' });
    setError('');
    setShowForm(true);
  };

  const handleSave = async () => {
    if (!form.name.trim() || !form.email.trim()) { setError('Nombre y email son obligatorios'); return; }
    setSaving(true); setError('');
    try {
      if (editing) await api.updateDepartment(editing.id, form);
      else         await api.createDepartment(form);
      setShowForm(false);
      load();
    } catch (e) { setError(e.message); }
    finally { setSaving(false); }
  };

  const handleToggle = async (d) => {
    await api.updateDepartment(d.id, { active: d.active ? 0 : 1 });
    load();
  };

  const handleDelete = async (d) => {
    if (!confirm(`¿Eliminar el departamento "${d.name}"?`)) return;
    await api.deleteDepartment(d.id);
    load();
  };

  return (
    <BackDeskLayout title="Departamentos de derivación"
      actions={
        <Button variant="primary" onClick={openNew}>+ Nuevo departamento</Button>
      }>

      {/* Modal formulario */}
      {showForm && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.35)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'#fff',borderRadius:12,width:440,boxShadow:'0 8px 40px rgba(0,0,0,.15)',overflow:'hidden'}}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #F3F4F6',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <span style={{fontSize:15,fontWeight:700,color:'#111827'}}>{editing ? 'Editar departamento' : 'Nuevo departamento'}</span>
              <button onClick={() => setShowForm(false)} style={{background:'none',border:'none',cursor:'pointer',fontSize:18,color:'#6B7280'}}>×</button>
            </div>
            <div style={{padding:'20px 24px',display:'flex',flexDirection:'column',gap:14}}>
              <div>
                <label style={{fontSize:11,fontWeight:600,color:'#6B7280',textTransform:'uppercase',letterSpacing:.4}}>Nombre *</label>
                <input value={form.name} onChange={e => setForm(f=>({...f,name:e.target.value}))}
                  placeholder="Ej: Recursos Humanos"
                  style={{width:'100%',marginTop:4,padding:'8px 10px',border:'1px solid #E5E7EB',borderRadius:7,fontSize:13,boxSizing:'border-box',outline:'none'}}/>
              </div>
              <div>
                <label style={{fontSize:11,fontWeight:600,color:'#6B7280',textTransform:'uppercase',letterSpacing:.4}}>Email de contacto *</label>
                <input value={form.email} onChange={e => setForm(f=>({...f,email:e.target.value}))}
                  placeholder="rrhh@uneatlantico.es" type="email"
                  style={{width:'100%',marginTop:4,padding:'8px 10px',border:'1px solid #E5E7EB',borderRadius:7,fontSize:13,boxSizing:'border-box',outline:'none'}}/>
              </div>
              <div>
                <label style={{fontSize:11,fontWeight:600,color:'#6B7280',textTransform:'uppercase',letterSpacing:.4}}>Descripción (opcional)</label>
                <input value={form.description} onChange={e => setForm(f=>({...f,description:e.target.value}))}
                  placeholder="Se mostrará en el email al usuario"
                  style={{width:'100%',marginTop:4,padding:'8px 10px',border:'1px solid #E5E7EB',borderRadius:7,fontSize:13,boxSizing:'border-box',outline:'none'}}/>
              </div>
              {error && <div style={{fontSize:12,color:'#B91C1C',background:'#FEF2F2',border:'1px solid #FECACA',borderRadius:6,padding:'6px 10px'}}>{error}</div>}
            </div>
            <div style={{padding:'14px 24px',borderTop:'1px solid #F3F4F6',display:'flex',justifyContent:'flex-end',gap:8}}>
              <Button variant="ghost" onClick={() => setShowForm(false)}>{t('general.cancel')}</Button>
              <Button variant="primary" onClick={handleSave} disabled={saving}>
                {saving ? 'Guardando…' : editing ? 'Guardar cambios' : 'Crear departamento'}
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Tabla */}
      <div style={{background:'#fff',border:'1px solid #E5E7EB',borderRadius:12,overflow:'hidden',boxShadow:'0 1px 3px rgba(0,0,0,.05)'}}>
        {loading ? (
          <div className="bd-loading"><div className="bd-spinner-sm"/>Cargando…</div>
        ) : depts.length === 0 ? (
          <div style={{padding:'48px 24px',textAlign:'center',color:'#9CA3AF'}}>
            <MIcon name="forward_to_inbox" size={36} color="#D1D5DB" style={{marginBottom:8}}/>
            <div style={{fontSize:14,marginTop:8}}>No hay departamentos configurados</div>
            <div style={{fontSize:12,marginTop:4}}>Crea el primero para poder derivar tickets</div>
          </div>
        ) : (
          <>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #F3F4F6',background:'#FAFAFA'}}>
            <input
              value={search} onChange={e => setSearch(e.target.value)}
              placeholder="Buscar departamento o email…"
              style={{width:'100%',height:34,padding:'0 12px',border:'1px solid #E5E7EB',borderRadius:7,fontSize:13,outline:'none',boxSizing:'border-box',background:'#fff'}}
            />
          </div>
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead>
              <tr style={{background:'#FAFAFA',borderBottom:'1px solid #F3F4F6'}}>
                <th style={{padding:'10px 16px',fontSize:10,fontWeight:700,textTransform:'uppercase',letterSpacing:.5,color:'#9CA3AF',textAlign:'left'}}>Departamento</th>
                <th style={{padding:'10px 16px',fontSize:10,fontWeight:700,textTransform:'uppercase',letterSpacing:.5,color:'#9CA3AF',textAlign:'left'}}>Email</th>
                <th style={{padding:'10px 16px',fontSize:10,fontWeight:700,textTransform:'uppercase',letterSpacing:.5,color:'#9CA3AF',textAlign:'left'}}>Descripción</th>
                <th style={{padding:'10px 16px',fontSize:10,fontWeight:700,textTransform:'uppercase',letterSpacing:.5,color:'#9CA3AF',textAlign:'center'}}>Estado</th>
                <th style={{padding:'10px 16px',width:100}}/>
              </tr>
            </thead>
            <tbody>
              {depts.filter(d => !search || d.name.toLowerCase().includes(search.toLowerCase()) || d.email.toLowerCase().includes(search.toLowerCase())).map(d => (
                <tr key={d.id} style={{borderBottom:'1px solid #F9FAFB'}}>
                  <td style={{padding:'12px 16px',fontSize:13,fontWeight:600,color:'#111827'}}>{d.name}</td>
                  <td style={{padding:'12px 16px',fontSize:13,color:'#0085CA'}}><a href={`mailto:${d.email}`}>{d.email}</a></td>
                  <td style={{padding:'12px 16px',fontSize:12,color:'#6B7280'}}>{d.description || '—'}</td>
                  <td style={{padding:'12px 16px',textAlign:'center'}}>
                    <span style={{
                      fontSize:11,fontWeight:600,padding:'2px 10px',borderRadius:10,
                      background: d.active ? '#F0FDF4' : '#F3F4F6',
                      color:      d.active ? '#15803D' : '#9CA3AF',
                      border:     `1px solid ${d.active ? '#86EFAC' : '#E5E7EB'}`,
                    }}>{d.active ? 'Activo' : 'Inactivo'}</span>
                  </td>
                  <td style={{padding:'12px 16px'}}>
                    <div style={{display:'flex',gap:6,justifyContent:'flex-end'}}>
                      <button onClick={() => openEdit(d)}
                        style={{padding:'4px 10px',borderRadius:6,border:'1px solid #E5E7EB',background:'#fff',cursor:'pointer',fontSize:11,color:'#374151'}}>
                        Editar
                      </button>
                      <button onClick={() => handleToggle(d)}
                        style={{padding:'4px 10px',borderRadius:6,border:'1px solid #E5E7EB',background:'#fff',cursor:'pointer',fontSize:11,color:'#374151'}}>
                        {d.active ? 'Desactivar' : 'Activar'}
                      </button>
                      <Button variant="danger" size="sm" onClick={() => handleDelete(d)}>
                        Eliminar
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </>
        )}
      </div>
    </BackDeskLayout>
  );
}
